export function parseContractRenewalSuffix(raw: string): string {
  return raw.trim().replace(/^A-/i, "");
}

/** Display-only helper (e.g. A-123456). Not used for API payloads. */
export function buildContractRenewalId(suffix: string): string {
  const normalizedSuffix = parseContractRenewalSuffix(suffix);
  if (!normalizedSuffix) return "";
  return `A-${normalizedSuffix}`;
}

/**
 * Value sent to the renewals API and stored in sessionStorage.
 * Preserves the original query param when present (matches legacy behaviour).
 */
export function resolveContractRenewalId(
  fromQuery: string,
  suffix: string,
): string {
  const query = fromQuery.trim();
  if (query) return query;
  return parseContractRenewalSuffix(suffix);
}

export function contractRenewalIdsMatch(a: string, b: string): boolean {
  const left = a.trim();
  const right = b.trim();
  if (!left || !right) return false;
  if (left === right) return true;
  return parseContractRenewalSuffix(left) === parseContractRenewalSuffix(right);
}
